import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { paymentActions } from "./actions";
import { PaymentState } from "./types";

const initialState: PaymentState = {};

export function PaymentReducer(
  state = initialState,
  action: Action,
): PaymentState {
  if (isType(action, paymentActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
